<template>
  <section>
    <base-background
      image="img/photos/photo3@2x.jpg"
      inner-class="bg-primary-dark-op"
    >
      <div class="content content-narrow content-full">
        <div
          class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center mt-5 mb-2 text-center text-sm-left"
        >
          <div class="flex-sm-fill">
            <h1 class="font-w600 text-white mb-0">
              {{ $t("dashboard.title") }}
            </h1>
            <h2 class="h4 font-w400 text-white-75 mb-0">
              {{ $t("dashboard.subtitle") }}
            </h2>
          </div>
          <div class="mt-3 mt-sm-0 ml-sm-3">
            <router-link
              to="/comparison_groups"
              class="btn btn-primary px-4 py-2"
            >
              {{ $t("comparisionGroups.title") }}
            </router-link>
          </div>
        </div>
      </div>
    </base-background>
    <div class="content content-narrow">
      <b-row>
        <b-col xl="6">
          <base-block
            :title="$t('dashboard.boxes.globalComparison.title')"
            header-bg
            content-full
          >
            <b-table-simple
              striped
              hover
              borderless
              class="table-vcenter font-size-sm mb-0"
            >
              <b-thead>
                <b-tr>
                  <b-th class="font-w700">{{
                    $t("dashboard.boxes.globalComparison.brand")
                  }}</b-th>
                  <b-th class="d-sm-table-cell font-w700">
                    <select
                      v-model="baseCompetitor"
                      @change="getGlobalComparison"
                      class="form-control"
                    >
                      <option
                        v-for="competitor in competitors"
                        v-bind:key="competitor.competitorId"
                        v-bind:value="competitor.competitorId"
                      >
                        {{ competitor.name }}
                      </option>
                    </select>
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="competitor in globalComparison.report"
                  :key="competitor.competitorId"
                >
                  <b-td
                    :class="{
                      'text-bold': baseCompetitor === competitor.competitorId
                    }"
                  >
                    {{ competitor.competitorName }}
                  </b-td>
                  <b-td
                    class="d-sm-table-cell"
                    :class="{
                      'text-green': competitor.relativePrice > 0,
                      'text-red': competitor.relativePrice < 0,
                      'text-bold': baseCompetitor === competitor.competitorId
                    }"
                  >
                    {{ $n(competitor.relativePrice, "percent") }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <br />
            <div class="text-right">
              <router-link
                to="/report"
                class="btn btn-sm btn-primary px-4 py-2"
              >
                {{ $t("dashboard.boxes.globalComparison.button") }}
              </router-link>
            </div>
          </base-block>
        </b-col>
        <b-col xl="6">
          <base-block
            :title="$t('dashboard.boxes.lastChanges.title')"
            header-bg
            content-full
          >
            <b-table-simple
              striped
              hover
              borderless
              class="table-vcenter font-size-sm mb-0"
            >
              <b-thead>
                <b-tr>
                  <b-th class="font-w700">{{
                    $t("dashboard.boxes.lastChanges.brand")
                  }}</b-th>
                  <b-th class="d-sm-table-cell font-w700">{{
                    $t("dashboard.boxes.lastChanges.date")
                  }}</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="competitor in lastPriceChanges"
                  :key="competitor.competitorId"
                >
                  <b-td>
                    {{ competitor.name }}
                  </b-td>
                  <b-td class="d-sm-table-cell">
                    {{ $d(new Date(competitor.lastPriceChange)) }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </base-block>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import Competitors from "@/assets/js/Competitors";
import Report from "@/assets/js/Report";
import Loading from "@/store/loading";

export default {
  components: {},
  name: "Home",
  data() {
    return {
      lastPriceChanges: [],
      globalComparison: [],
      competitors: [],
      baseCompetitor: 1
    };
  },
  methods: {
    getGlobalComparison() {
      Loading.dispatch("increase", 1);
      Report.get("", this.baseCompetitor, [], [], []).then(report => {
        this.$set(this, "globalComparison", report);
        Loading.dispatch("reduce");
      });
    }
  },
  mounted() {
    document.title = this.$t("dashboard.title");

    Loading.dispatch("increase", 3);

    Competitors.get().then(competitors => {
      this.$set(this, "competitors", competitors);
      Loading.dispatch("reduce");
    });

    Competitors.getLastPriceChange().then(competitors => {
      this.$set(this, "lastPriceChanges", competitors);
      Loading.dispatch("reduce");
    });

    Report.get("", this.baseCompetitor, [], [], []).then(report => {
      this.$set(this, "globalComparison", report);
      Loading.dispatch("reduce");
    });
  }
};
</script>
